import api from './api'

export const categoryService = {
  // Obtener todas las categorías
  getCategories: async () => {
    const response = await api.get('/categories')
    return response.data
  },

  // Obtener categoría por nombre
  getCategoryByName: async (name) => {
    const response = await api.get(`/categories/name/${encodeURIComponent(name)}`)
    return response.data
  },

  // Obtener categoría por ID
  getCategoryById: async (id) => {
    const response = await api.get(`/categories/${id}`)
    return response.data
  },

  // Obtener categorías específicas (Coronas de Reina y XV años)
  getSpecificCategories: async () => {
    const response = await api.get('/categories/specific')
    return response.data
  }
}

export default categoryService